export default "__VITE_ASSET__DtMBQFRl__"